// extracted by mini-css-extract-plugin
module.exports = {"container":"Values-module--container--sIreX","bottomLine":"Values-module--bottomLine--22a3s","list":"Values-module--list--2Kgth"};